import React, { useEffect, useState } from "react";
import { dataMap } from "@/constants/distribution";
// 引入 Less 样式
import "./TowerEffect.less";

// 模拟图片导入（需替换为实际图片路径）
import towerImage from "@/assets/xdt2.png";

const TowerEffect = (props: any) => {
    const {
        currentMode,
        setModalStatus,
        currentData,
        setCurrentData,
        currentModeData,
        wrapWidth = 250,
        imageStyle = null,
        trayHeight = 350,
        trayContainerStyle = {
            top: 60,
            left: 29,
            width: 53,
        },
        unit,                 // 自定义单位（覆盖dataMap默认单位）
    } = props;

    const [curColors, setCurColors] = useState<any>(null); // 当前热力图色谱

    // 数据变化时重新计算颜色
    useEffect(() => {
        if (currentModeData && Array.isArray(currentModeData) && currentModeData.length > 0) {
            setCurColors(buildeColors());
        }
    }, [currentModeData]);

    // 创建颜色块（核心逻辑保留）
    const buildeColors = () => {
        if (!currentModeData || currentModeData.length === 0) return [];

        const min = Math.min(...currentModeData);
        const max = Math.max(...currentModeData);

        // 处理数据没有波动的情况（所有值都相同）
        if (min === max) {
            // 所有塔板使用中间颜色（绿色），表示数值稳定
            return currentModeData.map(() => {
                return "rgba(0, 255, 0, 0.6)"; // 绿色
            });
        }

        // 为每个数据点创建颜色块
        return currentModeData.map((value: number) => {
            const normalizedValue = (value - min) / (max - min);
            const color = getColor(normalizedValue);
            return color;
        });
    };

    // 根据值获取颜色 - 5色系渐变（蓝色→青色→绿色→黄色→红色）
    const getColor = (value: number) => {
        // 确保value在[0,1]范围内
        const clampedValue = Math.max(0, Math.min(1, value));

        // 定义5个颜色节点
        const colors = [
            { r: 0, g: 0, b: 255 }, // 蓝色 (0.0)
            { r: 0, g: 255, b: 255 }, // 青色 (0.25)
            { r: 0, g: 255, b: 0 }, // 绿色 (0.5)
            { r: 255, g: 255, b: 0 }, // 黄色 (0.75)
            { r: 255, g: 0, b: 0 }, // 红色 (1.0)
        ];

        // 计算在5个颜色之间的位置
        const position = clampedValue * 4; // 映射到0-4范围
        const index = Math.floor(position);
        const remainder = position - index;

        // 安全检查
        if (!colors || index < 0 || index >= colors.length) {
            return "rgba(128, 128, 128, 0.6)"; // 灰色默认值
        }

        // 恰好是颜色节点
        if (remainder === 0) {
            const color = colors[index];
            if (color && typeof color.r === "number" && typeof color.g === "number" && typeof color.b === "number") {
                return `rgba(${color.r}, ${color.g}, ${color.b}, 0.6)`;
            }
            return "rgba(128, 128, 128, 0.6)";
        }

        // 线性插值计算渐变颜色
        const fromColor = colors[index];
        const toColor = colors[index + 1];

        if (!fromColor || !toColor ||
            typeof fromColor.r !== "number" || typeof fromColor.g !== "number" || typeof fromColor.b !== "number" ||
            typeof toColor.r !== "number" || typeof toColor.g !== "number" || typeof toColor.b !== "number") {
            const fallbackColor = colors[Math.min(index, colors.length - 1)];
            if (fallbackColor && typeof fallbackColor.r === "number" && typeof fallbackColor.g === "number" && typeof fallbackColor.b === "number") {
                return `rgba(${fallbackColor.r}, ${fallbackColor.g}, ${fallbackColor.b}, 0.6)`;
            }
            return "rgba(128, 128, 128, 0.6)";
        }

        const r = Math.round(fromColor.r + (toColor.r - fromColor.r) * remainder);
        const g = Math.round(fromColor.g + (toColor.g - fromColor.g) * remainder);
        const b = Math.round(fromColor.b + (toColor.b - fromColor.b) * remainder);

        return `rgba(${r}, ${g}, ${b}, 0.6)`;
    };

    // 显示模态框
    const showTrayModal = () => {
        // if (setModalStatus) {
        setModalStatus(true);
        // }
    };

    // 图例保留的小数位数
    const LEGEND_DECIMALS = 2;
    // 超出该量级（含）或低于下限时按科学计数法展示
    const SCI_UPPER = 1e9;
    const SCI_LOWER = 1e-3;

    // 按方向取整到 3 位小数：dir=1 向上取(ceil)，dir=-1 向下取(floor)
    // 数值过大/过小时先按数量级归一化，对尾数取整，避免 3 位小数被抹平
    const roundLegendValue = (v: number, dir: 1 | -1) => {
        if (!Number.isFinite(v)) return v;
        const abs = Math.abs(v);
        if (abs !== 0 && (abs >= SCI_UPPER || abs < SCI_LOWER)) {
            const exp = Math.floor(Math.log10(abs));
            const pow = Math.pow(10, exp);
            const mantissa = v / pow;
            const factor = Math.pow(10, LEGEND_DECIMALS);
            const scaled = mantissa * factor;
            const rounded = dir === 1
                ? Math.ceil(scaled - 1e-6)
                : Math.floor(scaled + 1e-6);
            return (rounded / factor) * pow;
        }
        const factor = Math.pow(10, LEGEND_DECIMALS);
        const scaled = v * factor;
        // 用相对容差消除二进制浮点误差（如 25.4*1000 = 25400.000000000004）
        const eps = abs * 1e-9;
        const rounded = dir === 1
            ? Math.ceil(scaled - eps)
            : Math.floor(scaled + eps);
        return rounded / factor;
    };

    // 图例数值展示：对齐真实数据、保留 3 位小数；过大/过小用科学计数法表示
    const formatLegendValue = (v: number) => {
        if (!Number.isFinite(v)) return String(v);
        const abs = Math.abs(v);
        if (abs !== 0 && (abs >= SCI_UPPER || abs < SCI_LOWER)) {
            return v.toExponential(LEGEND_DECIMALS);
        }
        return v.toFixed(LEGEND_DECIMALS);
    };

    // 获取图例最大值：对齐真实数据，向上取到 3 位小数
    const getMaxValue = () => {
        if (!currentModeData || currentModeData.length === 0) return formatLegendValue(0);
        const max = Math.max(...currentModeData);
        return formatLegendValue(roundLegendValue(max, 1));
    };

    // 获取图例最小值：对齐真实数据，向下取到 3 位小数
    const getMinValue = () => {
        if (!currentModeData || currentModeData.length === 0) return formatLegendValue(0);
        const min = Math.min(...currentModeData);
        return formatLegendValue(roundLegendValue(min, -1));
    };

    // 计算塔板项高度
    const getTrayItemHeight = (index: number) => {
        if (!currentModeData || currentModeData.length === 0) return 0;
        return trayHeight / currentModeData.length;
        // return currentData === index 
        //   ? trayHeight / currentModeData.length + 10 
        //   : trayHeight / currentModeData.length;
    };

    return (
        <div className="tower-effect-container" style={{ width: `${wrapWidth}px` }}>
            {/* 图片容器 */}
            <div className="img-container">
                {/* 塔板背景图 */}
                <div className="logo-img">
                    <img
                        src={towerImage}
                        alt="塔板示意图"
                        style={imageStyle || { height: '400px', width: '70px' }}
                    />
                </div>

                {/* 塔板热力图容器 */}
                <div
                    className="tray-container"
                    style={{
                        ...trayContainerStyle,
                        height: `${trayHeight}px`,
                        // top: `${trayContainerStyle.top}px`,
                        // left: `${trayContainerStyle.left}px`,
                        // width: `${trayContainerStyle.width}px`
                    }}
                >
                    {currentModeData && curColors && currentModeData.map((_: any, index: number) => (
                        <button
                            key={index}
                            className="tray-item"
                            style={{
                                backgroundColor: currentData === index ? "rgb(0,0,0)" : curColors[index] || "#ccc",
                                width: "200px",
                                height: `${getTrayItemHeight(index)}px`,
                                borderWidth: currentData === index ? "1px" : "0",
                                borderColor: currentData === index ? "rgb(255,255,255)" : "rgb(0,0,0)",
                                borderStyle: "solid",
                                margin: 0,
                                padding: 0,
                            }}
                            onClick={() => {
                                if (setCurrentData) {
                                    setCurrentData(index);
                                    showTrayModal();
                                }
                            }}
                        >
                            {currentData === index && (
                                <span className="tray-item-text">{index + 1}</span>
                            )}
                        </button>
                    ))}
                </div>

            </div>

            {/* 图例区域 */}
            <div className="legend-area">
                {/* 最大值 */}
                <div className="legend-value max-value">
                    <span className="value-number">{getMaxValue()}</span>
                    <span className="value-unit" style={{ fontStyle: 'italic', color: 'rgba(0,0,0,0.5)' }}>
                        {currentMode ? (unit || dataMap[currentMode]?.unit || '') : ''}
                    </span>
                </div>

                {/* 颜色渐变条 */}
                <div className="color-legend">
                    <div className="gradient-bar"></div>
                </div>

                {/* 最小值 */}
                <div className="legend-value min-value">
                    <span>{getMinValue()}</span>
                </div>
            </div>
        </div>
    );
};

export default TowerEffect;